import { Instance, types } from 'mobx-state-tree';

import TrackModel from './TrackModel';
import UserModel from './UserModel';

const QueueItemModel = types.model('QueueItemModel', {
    track: types.safeReference(TrackModel, { acceptsUndefined: false }),
    user: types.maybeNull(types.safeReference(UserModel)),
    order: types.optional(types.number, 0),
});

export interface IQueueItemModel extends Instance<typeof QueueItemModel> {}

export default QueueItemModel;
